import { Breadcrumb, Button, ButtonGroup, Modal, TitleScreen } from "components/Core"
import { schemaValidationQuerySchedule } from "utils/yup/schedule_schema"
import useForm from "hooks/useForm"
import FormQuerySchedule from "components/FormEntities/FormQuerySchedule"
import useOrchResources from "hooks/customs/useOrchResources"
import Swal from "sweetalert2"
import { Fragment, useRef, useState } from "react"
import cn from "classnames"
import usePreRender from "hooks/usePreRender"
import ContentModalOrderSchedule from "components/Custom/ContentModalOrderSchedule"
import translates from "overrides/theme/entel/base/translates/translation.json"
import { omitEmptyDeep } from "helpers/tools"

const QueryScreen = () => {
  const modal_ref = useRef<any>(null)
  let _translates: any = translates["schedule"]
  const { _color } = usePreRender()
  const { control, errors, handleSubmit, watch, setValue, isSubmitting } = useForm({
    defaultValues: {},
    schema: schemaValidationQuerySchedule,
  })
  const { set_loading_app, post_get_schedule_orders_action } = useOrchResources()
  const [data, set_data] = useState<any>(null)

  const on_submit = async (data: any) => {
    try {
      set_loading_app(true)
      let body: any = {
        shippingType: data?.shippingType,
        channel: data?.channel,
        shippingAddress: {
          country: data?.shippingAddress?.country?.id,
          region: data?.shippingAddress?.region?.id,
          location: omitEmptyDeep({
            // ...data?.shippingAddress?.location,
            province: data?.shippingAddress?.location?.province?.id,
            commune: data?.shippingAddress?.location?.commune?.id,
            latitude: data?.shippingAddress?.location?.latitude,
            longitude: data?.shippingAddress?.location?.longitude,
            address: data?.shippingAddress?.address,
          }),
        },
        contact: data?.contact,
        items: data?.items,
      }
      if (body?.shippingType.includes("SP") && data?.storePickupId) {
        Object.assign(body, { storePickupId: data?.storePickupId })
      }
      // if (data?.enableSimulatedDate && data?.simulatedDateValue) {
      //   Object.assign(body, { baseDate: `${data?.simulatedDateValue}T12:00:00` })
      // }
      const res: any = await post_get_schedule_orders_action({ body })
      set_data(res?.data?.message)
      if (res?.data?.code === 200) {
        modal_ref.current.open()
      }
      set_loading_app(false)
    } catch (error: any) {
      set_loading_app(false)
      const errorMessage = error?.response?.data?.message || "An error occurred"
      Swal.fire({
        title: "Error",
        text: JSON.stringify(`${errorMessage} - ${_translates[errorMessage] || ""}`),
        icon: "error",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#002EFE",
      })
    }
  }

  return (
    <Fragment>
      <div className="w-full h-full flex flex-col items-start justify-start pb-10">
        <Breadcrumb data={[{ name: "Consulta de agendamiento", href: "/orders/schedule/query" }]} />
        <div className="w-full flex flex-col justify-center items-center pt-4 px-6">
          <TitleScreen title="Consulta de agendamiento" />
        </div>
        <form className="w-full flex flex-col py-2 px-4" onSubmit={handleSubmit(on_submit)}>
          <div className="w-full flex flex-row items-center justify-end lg:pb-10 py-2">
            <ButtonGroup saveText="Consultar" savingText="Consultando..." isLoading={isSubmitting} />
          </div>
          <FormQuerySchedule control={control} errors={errors} watch={watch} setValue={setValue} />
          <div className="w-full flex flex-row items-center justify-end lg:py-10 py-2">
            <ButtonGroup saveText="Consultar" savingText="Consultando..." isLoading={isSubmitting} />
          </div>
        </form>
      </div>
      <Modal ref={modal_ref}>
        <div className="flex flex-col min-w-96 max-w-lg max-h-[600px] lg:w-auto">
          <div className={cn("w-full text-center rounded-t-xl p-2", `bg_${_color}`)}>
            <h4 className="text-lg font-medium uppercase text-white">Resultados</h4>
          </div>
          <div className="w-full flex flex-col rounded-b-xl gap-4 px-4 py-4">
            <div className="w-full flex flex-col max-h-96 rounded-b-xl gap-4 px-4 py-6 overflow-auto">
              <ContentModalOrderSchedule isOpen onClose={() => modal_ref.current.close()} shippingData={data} />
              <pre className="w-full h-full overflow-y-auto">
                <code className="text-sm text-gray-800 whitespace-pre-wrap">{JSON.stringify(data, null, 2)}</code>
              </pre>
            </div>
            <div className="flex flex-row justify-end items-end">
              <Button label="Ok" onClick={() => modal_ref.current?.close()} />
            </div>
          </div>
        </div>
      </Modal>
    </Fragment>
  )
}

export default QueryScreen
